import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const AboutUs2 = () => {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: "ease-out-cubic",
            once: false,
        });
    }, []);

    return (
        <section id="features" className="py-5" style={{ backgroundColor: "#ffffff" }}>
            <div className="container text-center">
                <div className="row">
                    <div className="col-12 col-md-4 py-2 mb-4"
                    style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #fff",
                        boxShadow:
                            "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                    }} >
                        {/* Tag */}
                        <div
                            className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
                            style={{
                                backgroundColor: "#ffffff",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                            data-aos="fade-up"
                        >
                            <span className="fw-bold text-dark">Our Mission</span>
                        </div>

                        {/* Heading */}
                        <h4
                            className="mb-4 fw-bold"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            make global literature accessible, contextual, and engaging for modern readers.
                        </h4>
                        <img
                            src="/media/shelf.jpg"  alt="About Us" className="img-fluid rounded-4 shadow-sm mb-4" style={{height:"280px", width:"100%", objectFit:"cover",}} data-aos="zoom-in" data-aos-delay="300"/>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            Our mission is to make global literature accessible, contextual, and engaging for modern readers.
                        </p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            We seek to remove the friction that prevents readers from discovering great works; whether that friction comes from unfamiliar languages, lack of cultural background, or overwhelming volumes of information. By presenting literature through concise summaries, author insights, and thoughtful organization, Biblivium empowers readers to explore confidently and intentionally.</p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            We believe discovery should feel inviting, not intimidating.</p>
                    </div>
                    <div className="col-12 col-md-4 bg-dark py-2 mb-4"
                    style={{
                        borderRadius: "10px",
                        border: "1px solid #fff",
                        boxShadow:
                            "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                    }} >
                        {/* Tag */}
                        <div
                            className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
                            style={{
                                backgroundColor: "#ffffff",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                            data-aos="fade-up"
                        >
                            <span className="fw-bold text-dark">Our Vision</span>
                        </div>

                        {/* Heading */}
                        <h4
                            className="mb-4 fw-bold"
                            style={{ maxWidth: "700px", margin: "0 auto", color: "#ffffff" }}
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            A world where readers freely explore literary traditions to understand humanity.
                        </h4>
                        <img src="/media/to-read.jpg" alt="About Us" className="img-fluid rounded-4 shadow-sm mb-4" style={{height:"280px", width:"100%", objectFit:"cover",}} data-aos="zoom-in" data-aos-delay="300"/>
                        <p className=" mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto", color: "#f6f6f6" }} data-aos="fade-up" data-aos-delay="200">
                            We envision a world where readers can move freely across literary traditions (French, Arabic, Japanese, Spanish, and beyond), gaining insight into humanity through its most enduring stories and ideas.
                        </p>
                        <p className=" mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto", color: "#f6f6f6" }} data-aos="fade-up" data-aos-delay="200">
                            Biblivium aspires to become a trusted global literary showcase: <br /> a place where readers come not for endless recommendations, but for clarity, quality, and cultural understanding.</p>
                        <p className=" mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto", color: "#f6f6f6" }} data-aos="fade-up" data-aos-delay="200">
                            As the platform grows, our vision remains rooted in careful expansion; adding new voices, languages, and perspectives while preserving the calm, focused experience that defines Biblivium.</p>
                    </div>
                    <div className="col-12 col-md-4 py-2 mb-4"
                    style={{
                        background: "#ffffff",
                        borderRadius: "10px",
                        border: "1px solid #fff",
                        boxShadow:
                            "0px 2px 10px rgba(28,28,28,0.08), inset 0 -6px 6px rgba(255,255,255,0.2)",
                    }} >
                        {/* Tag */}
                        <div
                            className="d-inline-block mb-3 px-3 py-1 rounded-pill border"
                            style={{
                                backgroundColor: "#ffffff",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                            data-aos="fade-up"
                        >
                            <span className="fw-bold text-dark">Our Philosophy</span>
                        </div>

                        {/* Heading */}
                        <h4
                            className="mb-4 fw-bold"
                            style={{ maxWidth: "700px", margin: "0 auto" }}
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            Literature is more than text; it is context, history, and human experience.
                        </h4>
                        <img
                            src="/media/nib.jpg"  alt="About Us" className="img-fluid rounded-4 shadow-sm mb-4" style={{height:"280px", width:"100%", objectFit:"cover",}} data-aos="zoom-in" data-aos-delay="300"/>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            At Biblivium, every work is presented with intention. We emphasize:
                        </p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            - Curated selection over exhaustive catalogs</p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            - Cultural context over surface-level summaries</p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            - Minimalist design over distracting interfaces</p>
                        <p className="text-muted mb-2 py-2" style={{ maxWidth: "700px", margin: "0 auto" }} data-aos="fade-up" data-aos-delay="200">
                            Our approach respects both the reader’s time and the author’s legacy, offering just enough insight to spark curiosity and deeper exploration.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};
